/**
 * Iter-60 — Sticky bottom mobile action bar.
 *
 * Renders a fixed action strip at the bottom of the viewport on mobile
 * only. Supports iOS safe-area via `env(safe-area-inset-bottom)`.
 * Used on dense edit pages (Landing-Page Editor, etc.) so Save /
 * Preview / Publish stay reachable no matter how tall the page grows.
 */
import React from "react";

export default function MobileStickyActions({ children, testId = "mobile-sticky-actions" }) {
  return (
    <>
      {/* Spacer so page content isn't hidden underneath the fixed bar. */}
      <div className="md:hidden h-16" aria-hidden="true" />
      <div
        className="md:hidden fixed left-0 right-0 bottom-0 z-30 bg-white border-t-2 border-black"
        style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
        data-testid={testId}
      >
        <div className="flex gap-2 p-2">{children}</div>
      </div>
    </>
  );
}
